



import React, { useState, useEffect, useRef } from "react";
import "./LandingSideBar2.css";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Add useNavigate 

import MenuIcon from "@mui/icons-material/Menu";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";

// Sidebar icons
import HomeIcon from "@mui/icons-material/Home";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import {
  Building,
  Settings,
  Utensils,
  Package,
  ShoppingBag,
  ChefHat,
  Table,
  Users,
  User,
  Tag,
  Star,
  Headphones,
  FileText,
  Bell,
  BarChart,
  Store,
  UserCog,
  UsersRound
} from "lucide-react";

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
} from "@mui/material";

import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";

/* =========================
   MENU CONFIGURATION
========================= */

const BACKEND_MODULES = {
  PLATFORM_ACCESS: "PLATFORM_ACCESS",
  VENDOR_PROFILE: "VENDOR_PROFILE",
  MENU_MANAGEMENT: "MENU_MANAGEMENT",
  ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
  TABLE_ORDERS: "TABLE_ORDERS",
  DELIVERY: "DELIVERY",
  INVENTORY_MANAGEMENT: "INVENTORY_MANAGEMENT",
  CHEF_MANAGEMENT: "CHEF_MANAGEMENT",
  TEAM_MANAGEMENT: "TEAM_MANAGEMENT",
  PROMOTIONS: "PROMOTIONS",
  REPORTS: "REPORTS",
  SUPPORT: "SUPPORT",
  ACCOUNT_HISTORY: "ACCOUNT_HISTORY",
  NOTIFICATIONS: "NOTIFICATIONS",
};

// Updated enumToMenuItemMap with Services dropdown  ACCOUNT_HISTORY: "ACCOUNT_HISTORY",
const enumToMenuItemMap = {
  Dashboard: {
    text: "Dashboard",
    icon: HomeIcon,
    route: "/homes",
    type: "link"
  },
  Company: {
    text: "Subscription",
    icon: Building,
    route: "/Foodsubscription",
    type: "link"
  },
  Client_Management: {
    text: "Client Management",
    icon: Settings,
    route: "/foodclientmanagement",
    type: "link"
  },


  Order_Management: {
    text: "Order Management",
    icon: ShoppingBag,
    route: "/foodordermanagement",
    type: "link"
  },


  Menu_Management: {
    text: "Menu Management",
    icon: ChefHat,
    route: "/foodmenumanagement",
    type: "link"
  },

  user_management: {
    text: "User Management",
    icon: Users,
    route: "/userdetails",
    type: "link"
  },
  Account_History: {
    text: "Account Management",
    icon: UserCog,
    route: "/foodaccountmanagement",
    type: "link"
  },

  Settings_Controls: {
    text: "Setting & Control",
    icon: Package,
    route: "/foodsettingmanagement",
    type: "link"
  },
  Team_Managment: {
    text: "Team Management",
    icon: UsersRound,
    route: "/teamlanding",
    type: "link"
  },

  Promotions_Discounts: {
    text: "Promotions & Marketing",
    icon: Tag,
    route: "/foodpramotions",
    type: "link"
  },
  Support_system: {
    text: "Support System",
    icon: Star,
    route: "/foodcare",
    type: "link"
  },

  Report_Analysis: {
    text: "Report & Analysis",
    icon: BarChart,
    route: "/foodreportmanagement",
    type: "link"
  },
};

/* =========================
   PREMIUM PROFESSIONAL LAYOUT
========================= */

const PremiumProfessionalLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate(); // Add useNavigate hook
  const sidebarRef = useRef(null);

  const [isOpen, setIsOpen] = useState(true);
  const [isHovering, setIsHovering] = useState(false);
  const [locationPopup, setLocationPopup] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const [currentLocation, setCurrentLocation] = useState(null);
  const [mapCenter, setMapCenter] = useState({
    lat: 28.6139,
    lng: 77.209,
  });

  const [address, setAddress] = useState("");
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");

  // Company name state
  const [companyName] = useState("Maamas Kitchen"); // You can make this dynamic later

  /* =========================
     HOVER TIMER REF
  ========================= */
  const hoverTimerRef = useRef(null);
  const [allowedModules, setAllowedModules] = useState([]);
  /* =========================
     LOAD SAVED DATA
  ========================= */
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("savedAddresses")) || [];
    const selected = localStorage.getItem("selectedAddress") || "";
    setSavedAddresses(saved);
    setSelectedAddress(selected);
  }, []);

  /* =========================
     CLEANUP TIMER
  ========================= */
  useEffect(() => {
    return () => {
      if (hoverTimerRef.current) {
        clearTimeout(hoverTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const role = localStorage.getItem("role");
    const storedModulesRaw = localStorage.getItem("businessModules");

    let storedModules = [];

    try {
      storedModules = storedModulesRaw ? JSON.parse(storedModulesRaw) : [];
    } catch (e) {
      console.error("❌ Failed to parse modules:", e);
    }

    console.log("👤 Role:", role);
    console.log("📦 Modules:", storedModules);

    // ✅ SUPER DUPER ADMIN → SHOW ALL
    if (role === "ROLE_SUPER_DUPER_ADMIN") {
      setAllowedModules(Object.entries(enumToMenuItemMap));
      console.log("🟢 SUPER DUPER ADMIN → showing ALL modules");
      return;
    }

    // ✅ NORMAL USERS → FILTER MODULES
    const normalizeModule = (name) => {
      const map = {
        "subscription": "Company"
      };
      return map[name] || name;
    };

    const filtered = Object.entries(enumToMenuItemMap).filter(([key]) =>
      storedModules
        .map(m => normalizeModule(m).toLowerCase())
        .includes(key.toLowerCase())
    );

    setAllowedModules(filtered);

  }, []);


  const renderMenuItems = () => {
    return allowedModules.map(([key, item]) => {
      const Icon = item.icon;

      return (
        <li
          key={key}
          className={`pp-menu-item ${location.pathname === item.route ? "pp-active" : ""
            }`}
        >
          <Link to={item.route} className="pp-menu-link">
            <Icon />
            {(isOpen || isHovering) && <span>{item.text}</span>}
          </Link>
        </li>
      );
    });
  };
  /* =========================
     CURRENT LOCATION
  ========================= */
  const handleUseCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const coords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      setCurrentLocation(coords);
      setMapCenter(coords);
      setAddress("Current Location");
    });
  };

  /* =========================
     MAP CLICK
  ========================= */
  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        setCurrentLocation(e.latlng);
        setMapCenter(e.latlng);
      },
    });
    return null;
  };

  /* =========================
     SAVE ADDRESS
  ========================= */
  const handleSaveAddress = () => {
    if (!currentLocation) return;

    const newAddress = {
      address,
      coords: currentLocation,
      type: "Saved",
    };

    const updated = [...savedAddresses, newAddress];
    setSavedAddresses(updated);

    localStorage.setItem("savedAddresses", JSON.stringify(updated));
    localStorage.setItem("selectedAddress", address);

    setSelectedAddress(address);
    setLocationPopup(false);
  };

  /* =========================
     TOGGLE DROPDOWN
  ========================= */
  const toggleDropdown = (key) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  /* =========================
     CHECK IF CHILD IS ACTIVE
  ========================= */
  const isChildActive = (children) => {
    return children.some(child => location.pathname === child.route);
  };

  /* =========================
     SIDEBAR HOVER HANDLERS
  ========================= */
  const handleSidebarMouseEnter = () => {
    if (!isOpen) {
      hoverTimerRef.current = setTimeout(() => {
        setIsHovering(true);
      }, 300); // 300ms delay before expanding
    }
  };

  const handleSidebarMouseLeave = () => {
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
    }
    setIsHovering(false);
  };

  /* =========================
     GET SIDEBAR CLASS
  ========================= */
  const getSidebarClass = () => {
    let baseClass = "pp-sidebar";
    baseClass += isOpen ? " pp-open" : " pp-closed";
    baseClass += isHovering && !isOpen ? " pp-hover-expand" : "";
    return baseClass;
  };

  /* =========================
     HANDLE LOGOUT
  ========================= */
  const handleLogout = () => {
    // Clear authentication data from localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("vendorId");
    // Close profile dropdown
    setProfileDropdown(false);
    // Navigate to login page
    navigate("/");
  };

  /* =========================
     RENDER MENU ITEMS
  ========================= */


  return (
    <div className="pp-layout">
      {/* NAVBAR */}
      <header className="pp-top-navbar">
        <div className="pp-nav-left">
          <MenuIcon
            className="pp-nav-icon"
            onClick={() => setIsOpen(!isOpen)}
          />
          <h2 className="pp-logo-text">
            <span className="pp-black">M</span>
            <span className="pp-red">aa</span>
            <span className="pp-black">maas</span>
          </h2>
        </div>

        {/* LOCATION */}
        {/* <div className="pp-nav-center">
          <button
            className="pp-location-btn"
            onClick={() => setLocationPopup(true)}
          >
            <LocationOnIcon />
            {selectedAddress || "Select Location"}
          </button>
        </div> */}

        {/* RIGHT */}
        <div className="pp-nav-right">
          <NotificationsOutlinedIcon className="pp-nav-icon" />

          <div className="pp-profile-wrapper">
            <AccountCircleIcon
              className="pp-profile-icon"
              onClick={() => setProfileDropdown(!profileDropdown)}
            />
            {profileDropdown && (
              <div className="pp-profile-dropdown">
                {/* <div className="pp-dropdown-item">Subscription</div> */}
                <div className="pp-dropdown-item" onClick={handleLogout}>Logout</div> {/* Add onClick handler */}
              </div>
            )}
          </div>
        </div>
      </header>

      {/* LOCATION POPUP */}
      {locationPopup && (
        <div className="pp-location-modal">
          <Paper
            elevation={4}
            sx={{
              width: "900px",
              display: "flex",
              overflow: "hidden",
              borderRadius: "12px",
            }}
          >
            <Box sx={{ width: "40%", p: 3 }}>
              {/* <Typography variant="h6" mb={2}>
                Select Location
              </Typography> */}

              <Button
                variant="contained"
                fullWidth
                onClick={handleUseCurrentLocation}
                sx={{ mb: 2 }}
              >
                Use My Current Location
              </Button>

              <TextField
                fullWidth
                placeholder="Search address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                sx={{ mb: 2 }}
              />

              {currentLocation && (
                <Button fullWidth variant="contained" onClick={handleSaveAddress}>
                  Save Address
                </Button>
              )}
            </Box>

            <Box sx={{ width: "60%" }}>
              <MapContainer
                center={[mapCenter.lat, mapCenter.lng]}
                zoom={15}
                style={{ height: "500px", width: "100%" }}
              >
                <TileLayer
                  attribution="&copy; OpenStreetMap"
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {currentLocation && (
                  <Marker position={[currentLocation.lat, currentLocation.lng]} />
                )}
                <MapClickHandler />
              </MapContainer>
            </Box>
          </Paper>
        </div>
      )}

      {/* SIDEBAR */}
      <div
        ref={sidebarRef}
        className={getSidebarClass()}
        onMouseEnter={handleSidebarMouseEnter}
        onMouseLeave={handleSidebarMouseLeave}
      >
        {/* Company Name Section - Always Visible */}
        {/* <div className="pp-company-section">
          <div className="pp-company-icon">
            <Store />
          </div>
          <div className={`pp-company-name ${!(isOpen || isHovering) ? 'pp-company-name-hidden' : ''}`}>
            {companyName}
          </div>
        </div> */}

        <ul className="pp-menu">
          {renderMenuItems()}
        </ul>
      </div>

      {/* CONTENT */}
      <div className={`pp-content ${(isOpen || isHovering) ? "pp-content-shift" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default PremiumProfessionalLayout;